import React, { Component } from 'react'
import {
  Switch,
  Route,
  Redirect,
  BrowserRouter as Router,
} from 'react-router-dom'
import Home from './Home/index'
import CommonProblem from './CommonProblem/index'
import CommonProblemDetail from './CommonProblem/detail'
import ContactUs from './ContactUs/index'
import VersionInfo from './VersionInfo/index'
import NotFound from './NotFound/index'
import Intro from './Intro/index'
import ProductDownload from './ProductDownload/index'
import IIPro from './production/ItIndex'
import ScpController from './ScpController/index'
import PolicyTW from './Policy/index_tw'
import PolicyCN from './Policy/index_cn'
import PolicyMY from './Policy/index_my'
import PolicyTH from './Policy/index_th'
import PolicyVN from './Policy/index_vn'
import PolicyUserTW from './PolicyUser/index_tw'
import PolicyUserCN from './PolicyUser/index_cn'
import PolicyUserMY from './PolicyUser/index_my'
import PolicyUserTH from './PolicyUser/index_th'
import PolicyUserVN from './PolicyUser/index_vn'
import ServiceRights from './ServiceRights/index'

class VMain extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/index" component={Home} />
        <Route exact path="/commonProblem" component={CommonProblem} />
        <Route exact path="/intro" component={Intro} />
        <Route
          exact
          path="/commonProblem/detail"
          component={CommonProblemDetail}
        />
        {/*<Route exact path="/versionInfo" component={VersionInfo} />*/}
        <Route exact path="/contactUs" component={ContactUs} />
        <Route exact path="/productDownload" component={ProductDownload} />
        <Route exact path="/notFound" component={NotFound} />
        <Route exact path="/itPro" component={IIPro} />
        <Route exact path="/scpcontroller" component={ScpController} />
        <Route exact path="/policy/tw" component={PolicyTW} />
        <Route exact path="/policy/vn" component={PolicyVN} />
        <Route exact path="/policy/my" component={PolicyMY} />
        <Route exact path="/policy/th" component={PolicyTH} />
        <Route exact path="/policy/cn" component={PolicyCN} />
        <Route exact path="/policy/user/tw" component={PolicyUserTW} />
        <Route exact path="/policy/user/vn" component={PolicyUserVN} />
        <Route exact path="/policy/user/my" component={PolicyUserMY} />
        <Route exact path="/policy/user/th" component={PolicyUserTH} />
        <Route exact path="/policy/user/cn" component={PolicyUserCN} />
        <Route exact path="/serviceRights" component={ServiceRights}  />
        <Route path="*" component={NotFound} />
        {/* <Route path='/404' component={NotFoundPage} /> */}

        <Redirect from="*" to="/404" />
      </Switch>
    )
  }
}
export default VMain
